/* eslint-disable no-unreachable */
import firebase from 'firebase/app';
import 'firebase/auth';

// Axios
import axios from 'axios';

// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// GraphQL
import AllUsers from '@/graphql/users/query/allUsers.gql';
import DeleteUser from '@/graphql/users/delete/deleteUser.gql';
import InsertUsers from '@/graphql/users/insert/insertUsers.gql';
import QueryUserByUid from '@/graphql/users/query/userByUid.gql';
import UpdateUser from '@/graphql/users/update/updateUser.gql';

export default {
	state: {
		currentUser: {
			id: '9f8ef50e-f857-433c-b94f-832ac36a8485',
			first_name: 'Chris',
			last_name: 'Baker',
			email: 'chris@bkrdev.com',
		},
		firebase: null,
		users: [],
	},

	// ================ Getters ================
	getters: {
		firebase(state: any) {
			return state.firebase;
		},

		currentUser(state: any) {
			return state.currentUser;
		},

		users(state: any) {
			return state.users;
		},
	},

	// ================ Mutations ================
	mutations: {
		resetAuthState(state: any) {
			// console.debug('Resetting auth state...');
			state.currentUser = null;
		},

		setCurrentUser(state: any, user: any) {
			state.currentUser = user;
		},

		setUsers(state: any, users: any) {
			state.users = users;
		},

		setFirebase(state: any, firebase: any) {
			state.firebase = firebase;
		},
	},

	// ================= Actions =================
	actions: {
		// =================================================
		// Sign use out of Firebase
		// =================================================

		async signOut({ state, commit }: any) {
			// console.debug('Signing out...');

			// Add firebase code
			await firebase
				.auth()
				.signOut()
				.catch(err => console.error('Sign Out Error', err));

			return;
		},

		// =================================================
		// Get Footy User by UID
		// =================================================

		async getFootyUserByUid({ state, commit }: any, uid: string) {
			const response: any = await apolloClient
				.mutate({
					mutation: QueryUserByUid,
					variables: {
						uid,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			const user = response.data.admin_users[0];

			commit('setCurrentUser', user);
		},

		// =================================================
		// Get Footy User by UID
		// =================================================

		async getFootyUsers({ state, commit }: any, uid: string) {
			const response: any = await apolloClient
				.query({
					query: AllUsers,
					variables: {
						uid,
					},
					fetchPolicy: 'no-cache',
				})
				.catch(err => {
					console.debug(err);
				});

			const users = response.data.admin_users;

			commit('setUsers', users);

			return;
		},

		// =================================================
		// Get Footy User by UID
		// =================================================

		async insertAdminUser({ state, commit, dispatch }: any, { user }: any) {
			try {
				console.log('insertAdminUser');
				console.log(user);

				const res = await axios({
					url: 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/lm/user',
					method: 'POST',
					data: user,
				});

				if (!res.data.success) {
					console.log(res.data);
					throw new Error(res.data.message);
				}

				const { hasuraUser } = res.data;

				const footyUser = {
					...hasuraUser,
					first_name: user.firstName,
					last_name: user.lastName,
					email: user.email,
				};

				const response = await apolloClient
					.mutate({
						mutation: InsertUsers,
						variables: {
							objects: [footyUser],
						},
					})
					.catch(err => {
						console.debug(err);
					});

				await dispatch('getFootyUsers');

				return true;
			} catch (error) {
				const errorMessage = error.response.data.message;
				return errorMessage !== undefined ? errorMessage : 'Server error';
			}
		},

		// =================================================
		// Get Footy User by UID
		// =================================================

		async updateUser({ state, commit, dispatch }: any, user: any) {
			const { firebase_uid } = state.users.find((u: HasuraUser) => u.id === user.id);
			console.log(user);
			const res: any = await axios({
				url: 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/lm/user',
				method: 'PUT',
				data: { ...user, firebase_uid },
			}).catch(err => console.log(err));

			if (res && !res.data.success) {
				console.log(res.data);
				throw new Error(res.data.message);
			}

			const hasuraUser = res.data.hasuraUser;

			await apolloClient.mutate({
				mutation: UpdateUser,
				variables: {
					userId: hasuraUser.id,
					firstName: hasuraUser.firstName,
					lastName: hasuraUser.lastName,
					phoneNumber: hasuraUser.phoneNumber,
					email: hasuraUser.email,
					country: hasuraUser.country,
				},
			});

			await dispatch('getFootyUsers');

			return;
		},

		// =================================================
		// Delete Footy User
		// =================================================

		async deleteUser({ state, dispatch }: any, user: any) {
			const { id, firebase_uid } = user;

			// Block user from deleting their own account
			if (state.currentUser.firebase_uid === firebase_uid) {
				throw new Error('You can not delete your own account');
			}

			// Delete user from Footy database
			await apolloClient.mutate({
				mutation: DeleteUser,
				// Parameters
				variables: {
					userId: id,
				},
			});

			// Delete user from Firebase
			const res = await axios({
				url: 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/lm/user',
				method: 'DELETE',
				data: { uid: firebase_uid },
			});

			if (!res.data.success) {
				console.log(res.data);
				throw new Error(res.data.message);
			}

			await dispatch('getFootyUsers');

			return;
		},
	},
};
